import { Link as RouterLink } from 'react-router-dom';

import { BoltMerchantLogoIcon } from '../icons/BoltMerchantLogoIcon';

export const NavBarLogo = () => {
  return (
    <div className="pl-3">
      <RouterLink to="/">
        <BoltMerchantLogoIcon />
      </RouterLink>
    </div>
  );
};
